import { render } from "./StudentPortalShellView.vue?vue&type=template&id=34992278&scoped=true"
import script from "./StudentPortalShellView.vue?vue&type=script&lang=js"
export * from "./StudentPortalShellView.vue?vue&type=script&lang=js"

import "./StudentPortalShellView.vue?vue&type=style&index=0&id=34992278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34992278"]])

export default __exports__